import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Constants} from "../../constants";
import {Service} from "../../models/service";

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private http: HttpClient) { }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: environment.publicApiToken,
    });
  }

  async getAllServices(visibleOnly = true){
    let services: Service[] = [];

    try {
      const url = environment.publicApiUrl + '/services' + (visibleOnly ? '?visible=1' : '');
      let response: any = await this.http.get(url, {headers: this.getPublicRequestHeaders()}).toPromise();
      if (response.success) {
        console.log('service service data: ', response.data)
        services = response.data;
      }
    } catch (e) {
      console.error('Error in Category service getAllServices: ', e)
    } finally {
      return services;
    }
  }

  async getServiceById(id: string): Promise<Service | null> {
    try {
      const response: any = await this.http.get(environment.publicApiUrl + `/services/${id}`, {headers: this.getPublicRequestHeaders()}).toPromise();
      if (response.success && response.data) {
        return new Service(response.data);
      }
    } catch (e) {
      console.error('Error in Service service getServiceById:', e);
    }
    return null;
  }

  async getCompanyCurrentServices() {
    let services: Service[] = [];

    try {
      let response: any = await this.http.get(environment.publicApiUrl + '/services/currentSubscription', {headers: this.getPublicRequestHeaders()}).toPromise();
      if (response.success) {
        services = response.data;
      }
    } catch (e) {
      console.error('Error in Service service getCompanyCurrentServices: ', e)
    } finally {
      return services;
    }
  }
}
